import { HStack } from '@web/components/atoms/Layout'
import { Body2 } from '@web/components/atoms/Typography'
import {
  DONATION_FREQUENCY_TO_LABEL,
  useGivingFrequency,
  usePayByInstallment,
  useTotalAmount,
} from '../../donationUtils'
import { toDisplayAmountNoDecimal } from '@web/components/utils/format'
import { useDonationFormContext } from '../../DonationFormProvider'
import { useMemo } from 'react'
import { Decimal } from 'decimal.js'
import { DonationFrequency } from '@web/graphql-components'

type TotalAmountProps = {
  donorPaysAmount?: number
}

const TotalAmount = ({ donorPaysAmount = 0 }: TotalAmountProps) => {
  const baseAmount = useTotalAmount()
  const isDonorPays = useDonationFormContext((state) => state.formValues.isDonorPays)
  const isPayByInstallments = useDonationFormContext((state) => state.formValues.isPayByInstallments)
  const givingFrequency = useGivingFrequency()
  const { noOfInstallments } = usePayByInstallment()
  const totalAmount = useMemo(() => {
    let base = new Decimal(baseAmount)

    if (isPayByInstallments && noOfInstallments) {
      base = base.div(noOfInstallments[0]).toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
    }

    if (isDonorPays) {
      base = base.add(donorPaysAmount)
    }

    return base.toNumber()
  }, [baseAmount, isDonorPays, isPayByInstallments, noOfInstallments, donorPaysAmount])

  return (
    <HStack>
      <Body2 fontWeight={600} as="strong" fontSize="1rem">
        {isPayByInstallments && `Today's`} Total{' '}
        {givingFrequency !== DonationFrequency.OneTime ? `${DONATION_FREQUENCY_TO_LABEL[givingFrequency]} ` : ''}Amount:
      </Body2>
      <Body2 fontSize="1rem">{`$${toDisplayAmountNoDecimal(totalAmount)}`}</Body2>
    </HStack>
  )
}

export default TotalAmount
